












































































































































import UUIFComponent from '@/shared/uuifComponent';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import {
  SwTable,
  TableColumnConfig,
  TableEntry,
  TableEntrySelectingEventData,
} from '@sonicwall/unified-ui-framework/src/shared/sw-table';
import { Component } from 'vue-property-decorator';
import { SwTextarea } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import { SwMessageContainer } from '@libs-uuif/shared/message-service';
import { messageService } from '@sonicwall/unified-ui-framework/src/shared/message-service';

const cssPrefix = 'msw-atp-taining';

@Component({
  components: { SwTable, SwTextarea, ...UUIFComponent, SwMessageContainer },
})
export default class MswAtpTraining extends SwExtendedVue {
  cssPrefix = cssPrefix;

  activationKeys: string = '';
  activationKeysArray = [];
  selectedRowsKeys: any = [];
  get selectedColumnsConfig(): TableColumnConfig[] {
    return [
      {
        key: 'selection',
        type: 'selection',
      },
      {
        key: 'select',
        dataKey: 'select',
        title: (this.$t('atpTraining.selectAll')
        .toString()),
      },
      {
        key: 'key',
        dataKey: 'activationKey',
        title: (this.$t('atpTraining.actKey')
        .toString()),
      },
      {
        key: 'status',
        dataKey: 'status',
        title: (this.$t('common.status')
        .toString()),
      },
    ];
  }
  basicData: any = [];

  get tableData(): TableEntry[] {
    return this.basicData.map((ele: any, index: any) => {
      return {
        _key: index,
        _selectable: ele.status === 'key not recognized' ? false : true,
        select: ele.status === 'key not recognized' ? 'N/A' : '',
        activationKey: ele.key,
        status: ele.status,
      };
    });
  }
  get getKeys() {
    return this.$store.getters['AtpTrainingStoreModule/getKeys'];
  }

  onEntrySelecting(data: TableEntrySelectingEventData) {
    const selectedKey: any = data.entryKey;
    if (data.selecting) {
      this.selectedRowsKeys.push(selectedKey);
    } else {
      if (this.selectedRowsKeys.length > 0) {
        const selectedEntryIndex = this.selectedRowsKeys.indexOf(selectedKey);
        this.selectedRowsKeys.splice(selectedEntryIndex, 1);
      }
    }
  }
  reset() {
    this.activationKeys = '';
    this.$store.commit('AtpTrainingStoreModule/setKeys');
  }
  searchKeys() {
    const splittedKeys = this.activationKeys.split(/\r?\n|\r?,/g)
    .map((val) => {
      return val.trim();
    });
    if (this.activationKeys.length > 0) {
      this.$store
        .dispatch('AtpTrainingStoreModule/searchKeys', splittedKeys)
        .then((response) => {
          this.$store.commit('stopLoading');
          if (response.operationStatus === 'OK' || response.msgCode === 'MSWAPP:SUCCESS') {
            this.basicData = response.content;
            this.$store.commit('AtpTrainingStoreModule/setKeys', response.content);
          } else {
            messageService.messageManager.showMessage(
              'atp-training',
              response.msgDesc,
              'failed',
            );
          }
        });
    } else {
      messageService.messageManager.showMessage('atp-training', 'Please input keys', 'failed');
    }
  }

  markAsUsed() {
    const selectedKeys = [];
    for (const i of this.selectedRowsKeys) {
      selectedKeys.push(this.basicData[i].key);
    }
    if (selectedKeys.length > 0) {
      this.$store
        .dispatch('AtpTrainingStoreModule/markAsUsed', selectedKeys)
        .then((response) => {
          this.$store.commit('stopLoading');
          if (response.operationStatus === 'OK' || response.msgCode === 'MSWAPP:SUCCESS') {
            messageService.messageManager.showMessage(
              'atp-training',
              response.msgDesc,
              'success',
            );
            this.selectedRowsKeys = [];
          } else {
            messageService.messageManager.showMessage(
              'atp-training',
              response.msgDesc,
              'failed',
            );
          }
        });
    }
  }
}
